
import { Table, Tabs } from "antd";
import { UserOutlined, FileTextOutlined } from "@ant-design/icons";
import { useTranslation } from 'react-i18next';

const TabsTable = (props) => {
    const { t } = useTranslation();

    const documentsData = [
        { no: 1, name: "Proposal.docx", views: 25 },
        { no: 2, name: "Marketing Plan.pdf", views: 18 },
        { no: 3, name: "Budget.xlsx", views: 37 },
        { no: 4, name: "Product Requirements.txt", views: 9 },
        { no: 5, name: "Meeting Minutes.docx", views: 42 },
    ];

    const usersData = [
        { no: 1, name: "John Doe", downloads: 12 },
        { no: 2, name: "Jane Smith", downloads: 5 },
        { no: 3, name: "Peter Lee", downloads: 28 },
        { no: 4, name: "Emily Johnson", downloads: 15 },
        { no: 5, name: "David Miller", downloads: 7 },
    ];

    const items = [
        {
            label: t('Documents'),
            key: "1",
            children: (
                <Table
                    size="small"
                    pagination={false}
                    dataSource={documentsData}
                    columns={[
                        { title: t('No'), dataIndex: "no", key: "no", width: "20%" },
                        {
                            title: t('Document Name'),
                            dataIndex: "name",
                            key: "name",
                            width: "60%"
                        },
                        { title: t('Views'), dataIndex: "views", key: "views", width: "20%" },
                    ]}
                    style={{ padding: 0, margin: "0px" }}
                />
            ),
            icon: <FileTextOutlined />,
        },
        {
            label: t('Users'),
            key: "2",
            children: (
                <Table
                    size="small"
                    pagination={false}
                    dataSource={usersData}
                    columns={[
                        { title: t('No'), dataIndex: "no", key: "no", width: "20%" },
                        { title: t('User Name'), dataIndex: "name", key: "name",  width: "60%" },
                        {
                            title: t('Downloads'),
                            dataIndex: "downloads",
                            key: "downloads",
                            width: "20%"
                        },
                    ]}
                    style={{ padding: 0, margin: 0 }}
                />
            ),
            icon: <UserOutlined />,
        },
    ];


    return (
        <div className="reports-table">
            <Tabs
                style={{
                    marginBottom: "0",
                    border: "1px #F0F0F0 solid",
                    borderRadius: "10px",
                    paddingTop: 10
                }}
                centered={false}
                size="small"
                defaultActiveKey="1"
                items={items}
            />

        </div>
    )
}

export default TabsTable